import React from 'react';
import PropTypes from 'prop-types';
import { LINK } from 'constants/components';
import { SECTIONS_PATH } from 'constants/navigation';
import LinkElement from './Link.styled';

export const Link = props => {
  let { text, size, layout, onClick, onBlur, href } = props;
  return (
    <LinkElement
      size={size}
      href={href}
      layout={layout}
      onBlur={onBlur}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
      onKeyPress={event => {
        event.preventDefault();
        onClick();
      }}
    >
      {text}
    </LinkElement>
  );
};

Link.propTypes = {
  text: PropTypes.string,
  size: PropTypes.number,
  layout: PropTypes.oneOf([LINK.LAYOUT.DEFAULT, LINK.LAYOUT.FORM]),
  onClick: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  href: PropTypes.string
};

Link.defaultProps = {
  layout: LINK.LAYOUT.DEFAULT,
  href: `#${SECTIONS_PATH}`,
  size: 13
};

export default Link;
